import { Component } from 'vue-property-decorator'
import { parseToNumber } from '@/utils/general'
import { AppraisalView } from '@/components/forms/view/AppraisalView'
import { FileProcess } from '@/entities/files'

@Component
export class NegotiationView extends AppraisalView {
  statusNegotiation = {
    appealed: null,
    appealedAnswered: null,
    readingFile: null,
    approved: null,
    rejected: null,
    closed: null,
    legalReview: null,
    toUpdate: null,
  }

  closingReason = {
    inValidDocument: null,
    success: null,
  }

  async mounted () {
    this.statusNegotiation.appealed = await this.fetchData({
      query: { name: 'find', model: 'ProcessStatus' },
      filter: { _and: [{ process: { table_name: { _eq: 'negotiation' } } }, { status: { name: { _eq: 'appealed' } } }] },
    })
    this.statusNegotiation.appealedAnswered = await this.fetchData({
      query: { name: 'find', model: 'ProcessStatus' },
      filter: { _and: [{ process: { table_name: { _eq: 'negotiation' } } }, { status: { name: { _eq: 'appeal_answered' } } }] },
    })
    this.statusNegotiation.readingFile = await this.fetchData({
      query: { name: 'find', model: 'ProcessStatus' },
      filter: { _and: [{ process: { table_name: { _eq: 'negotiation' } } }, { status: { name: { _eq: 'reading_file' } } }] },
    })
    this.statusNegotiation.approved = await this.fetchData({
      query: { name: 'find', model: 'ProcessStatus' },
      filter: { _and: [{ process: { table_name: { _eq: 'negotiation' } } }, { status: { name: { _eq: 'approved' } } }] },
    })
    this.statusNegotiation.rejected = await this.fetchData({
      query: { name: 'find', model: 'ProcessStatus' },
      filter: { _and: [{ process: { table_name: { _eq: 'negotiation' } } }, { status: { name: { _eq: 'rejected' } } }] },
    })
    const filter = {
      _and: [
        { type: { name: { _eq: 'invalid_document' } } },
        { status: { process: { table_name: { _eq: 'negotiation' } } } },
      ],
    }

    this.closingReason.inValidDocument = await this.fetchData({ query: { name: 'find', model: 'ClosingReason' }, filter })

    this.statusNegotiation.closed = await this.fetchData({
      query: { name: 'find', model: 'ProcessStatus' },
      filter: { _and: [{ process: { table_name: { _eq: 'negotiation' } } }, { status: { name: { _eq: 'closed' } } }] },
    })

    const filterSuccess = {
      _and: [
        { type: { name: { _eq: 'successful' } } },
        { status: { process: { table_name: { _eq: 'negotiation' } } } },
      ],
    }

    this.closingReason.success = await this.fetchData({
      query: { name: 'find', model: 'ClosingReason' },
      filter: filterSuccess,
    })

    this.statusNegotiation.legalReview = await this.fetchData({
      query: { name: 'find', model: 'ProcessStatus' },
      filter: { _and: [{ process: { table_name: { _eq: 'negotiation' } } }, { status: { name: { _eq: 'legal_review' } } }] },
    })

    this.statusNegotiation.toUpdate = await this.fetchData({
      query: { name: 'find', model: 'ProcessStatus' },
      filter: { _and: [{ process: { table_name: { _eq: 'negotiation' } } }, { status: { name: { _eq: 'to_update' } } }] },
    })
  }

  async insertNegotiationAppealed (formData, negotiation, idEmployee, type = 'appealed') {
    const { expectedPrice } = formData
    let response
    const insertAppealed = !negotiation.status.isAppealed && type === 'appealed'
    const insertAppealedResponse = !negotiation.status.isAppealAnswered && type === 'offer'
    if (insertAppealed || insertAppealedResponse) {
      response = await this.insertResponse(expectedPrice, idEmployee, negotiation, type)
    } else {
      if (parseToNumber(expectedPrice) !== parseToNumber(negotiation.lastResponse.amount)) {
        await this.updateResponse(expectedPrice, negotiation)
      }
    }

    if (response) {
      const idProcessStatus = type === 'offer' ? this.statusNegotiation.appealedAnswered?.[0]?.id : this.statusNegotiation.appealed?.[0]?.id
      await this.pushData({
        model: 'Negotiation',
        fields: { id: negotiation.id, id_process_status: idProcessStatus },
      })
    }
  }

  async insertResponse (expectedPrice, idEmployee, negotiation, type) {
    return this.pushData({
      model: 'NegotiationResponse',
      fields: {
        amount: parseToNumber(expectedPrice),
        id_employee: idEmployee,
        id_negotiation: negotiation.id,
        type,
      },
    })
  }

  async updateResponse (expectedPrice, negotiation) {
    await this.pushData({
      model: 'NegotiationResponse',
      fields: {
        id: negotiation.lastResponse.id,
        amount: parseToNumber(expectedPrice),
      },
    })
  }

  async insertAgreedAmount (viewData) {
    const { formData, negotiation } = viewData

    await this.pushData({
      model: 'Negotiation',
      fields: {
        id: negotiation.id,
        agreed_amount: formData.expectedPrice,
        id_process_status: this.statusNegotiation.readingFile?.[0]?.id,
      },
    })
  }

  async insertUpdateFile (viewData) {
    const {
      idProcess,
      formData: { cav, legalReport, penalties, linkLegalReport },
      fields: { cav: cavField, legalReport: legalReportField, penalties: penaltiesField },
      negotiation: { id, inspection: { appraisal: { deal: { id: idDeal } } } },
    } = viewData

    if (cav?.length) {
      const fileParameters = await this.fetchData({
        query: { name: 'find', model: 'FileParameter' },
        filter: { process: { table_name: { _eq: 'negotiation' } } },
      })
      const cavParameter = fileParameters.filter(parameter => parameter.name === 'cav')
      const file = await this.handleFileType(cav, cavField, idProcess, id, cavParameter)

      if (file?.length) {
        const fileProcess = file[0] as FileProcess
        if (fileProcess?.id) {
          await this.fileProcessing({ idDeal, idFileProcess: fileProcess?.id })
          await this.pushData({
            model: 'Negotiation',
            fields: {
              id,
              id_process_status: this.statusNegotiation.readingFile?.[0]?.id,
            },
          })
        }
      }
    }
    if (legalReport?.length) {
      await this.handleFileType(legalReport, legalReportField, idProcess, id)
      const fileId = this.isArrayFiles(legalReport) ? legalReport[0]?.id : legalReport?.[0]?.file?.id
      const fields = { id: fileId, source_link: linkLegalReport }
      await this.pushData({ model: 'File', fields })
    }

    if (penalties?.length) {
      const file = await this.handleFileType(penalties, penaltiesField, idProcess, id)
      if (file?.length) {
        const fileProcess = file[0] as FileProcess
        if (fileProcess?.id) {
          await this.fileProcessing({ idDeal, idFileProcess: fileProcess?.id })
          await this.pushData({
            model: 'Negotiation',
            fields: {
              id,
              id_process_status: this.statusNegotiation.readingFile?.[0]?.id,
            },
          })
        }
      }
    }
  }

  async negotiationHandleStatus (viewData) {
    const { formData: { legalApproved, executiveUpdate, options }, formData, negotiation, pendingPenalties } = viewData
    if (legalApproved && !pendingPenalties) {
      await this.pushData({
        model: 'Negotiation',
        fields: {
          id: negotiation.id,
          id_process_status: this.statusNegotiation.approved?.[0]?.id,
        },
      })

      await this.changeValidFileProcess(formData.cav[0])
      await this.changeValidFileProcess(formData.legalReport[0])
      await this.changeValidFileProcess(formData.penalties[0])
    } else {
      if (!executiveUpdate && !pendingPenalties) {
        await this.pushData({
          model: 'Negotiation',
          fields: {
            id: negotiation.id,
            id_process_status: this.statusNegotiation.rejected?.[0]?.id,
            id_closing_reason: this.closingReason.inValidDocument?.[0]?.id,
          },
        })
        await this.changeValidFileProcess(formData.cav[0], false)
        await this.changeValidFileProcess(formData.legalReport[0], false)
        await this.changeValidFileProcess(formData.penalties[0], false)
      } else {
        await this.pushData({
          model: 'Negotiation',
          fields: {
            id: negotiation.id,
            id_process_status: this.statusNegotiation.toUpdate?.[0]?.id,
          },
        })

        if (options?.length) {
          for (const key of options) {
            if (formData[key]?.length) {
              await this.insertFileProcessInfo({ id: formData[key][0]?.id, comment: 'Debe actualizar el archivo' })
            }
          }
        }
      }
    }
  }

  async getPenalties (idFileProcess) {
    if (!idFileProcess) return
    const processTrafficTickets = await this.fetchData({
      query: { name: 'find', model: 'ProcessTrafficTicket' },
      filter: { id_file_process: { _eq: idFileProcess } },
      force: true,
    })

    return processTrafficTickets || []
  }

  async changeStatusLegalReview (negotiation) {
    await this.pushData({
      model: 'Negotiation',
      fields: {
        id: negotiation.id,
        id_process_status: this.statusNegotiation.legalReview?.[0]?.id,
      },
    })
  }
}
